function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, useMemo } from 'react';
import { computeCartesianTicks } from '../lib/compute';
import moment from 'moment';

class Axis extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderLabel", (value, format) => {
      if (format === "MONTH") {
        const month = moment(value).format('MMMM');
        let classNames = [];
        classNames.push('tick__label');
        const className = classNames.join(' ');
        return React.createElement("g", {
          className: className
        }, React.createElement("text", {
          className: "tick__month"
        }, month));
      }

      if (format === "WEEK") {
        const w1 = moment(value).format();
        const w2 = moment(value).endOf("week").format();
        let classNames = [];
        classNames.push('tick__label');
        const date1 = moment(w1).format('DD.MM');
        const date2 = moment(w2).format('DD.MM');
        const w = moment(w1).isoWeek();
        const className = classNames.join(' ');
        return React.createElement("g", {
          className: className
        }, React.createElement("text", {
          className: "tick__start"
        }, date1, "\u2013"), React.createElement("text", {
          className: "tick__end"
        }, date2));
      }

      if (format === "DATE") {
        const year = moment(value).format('Y');
        const month = moment(value).format('MMM');
        const day = moment(value).format('DD');
        let classNames = [];
        classNames.push('tick__label');
        const className = classNames.join(' ');
        return React.createElement("g", {
          className: className
        }, React.createElement("text", {
          className: "tick__day"
        }, day), React.createElement("text", {
          className: "tick__month"
        }, month));
      }

      if (format === "HOUR") {
        const hour = moment(value).format('HH:mm');
        return React.createElement("text", {
          className: "tick__label"
        }, hour);
      }

      if (format === "MINUTE") {
        const hour = moment(value).format('HH:mm');
        return React.createElement("text", {
          className: "tick__label"
        }, hour);
      }

      if (format === "PERCENT") {
        value = parseFloat(value);
        value = value.toFixed(0) + "%";
        return React.createElement("text", {
          className: "tick__label"
        }, value);
      }

      if (format === "TIME") {
        const time = moment().startOf('day').add(value, "seconds").format('H:m:ss');
        const split = time.split(":");
        const hours = split[0];
        const minutes = split[1];
        const seconds = split[2];

        if (hours >= 1) {
          value = hours + 'h ' + minutes + 'm ' + seconds + 's';
        } else {
          value = minutes + 'm ' + seconds + 's';
        }

        return React.createElement("text", {
          className: "tick__label"
        }, value);
      }

      if (format === "INTEGER") {
        value = new Intl.NumberFormat('de-DE').format(value);
        return React.createElement("text", {
          className: "tick__label"
        }, value);
      }

      return React.createElement("text", {
        className: "tick__label"
      }, value);
    });

    _defineProperty(this, "renderTick", (props, index) => {
      let _this$props = this.props,
          axis = _this$props.axis,
          position = _this$props.position,
          scale = _this$props.scale,
          format = _this$props.format,
          dimension = _this$props.dimension,
          startDate = _this$props.startDate,
          endDate = _this$props.endDate;
      let x = props.x,
          y = props.y,
          lineX = props.lineX,
          lineY = props.lineY,
          textX = props.textX,
          textY = props.textY,
          textAnchor = props.textAnchor,
          textBaseline = props.textBaseline,
          rotate = props.rotate,
          value = props.value;

      if (format === "STRING" && dimension === "ga:nthMonth" && startDate) {
        format = "MONTH";
        value = moment(startDate).startOf('month').add(value, "months");
      }

      if (format === "STRING" && dimension === "ga:nthWeek" && startDate) {
        format = "WEEK";
        value = moment(startDate).startOf('week').add(value, "weeks");
      }

      if (format === "STRING" && dimension === "ga:nthDay" && startDate) {
        format = "DATE";
        value = moment(startDate).add(value, "days");
      }

      if (format === "STRING" && dimension === "ga:nthHour" && startDate) {
        format = "HOUR";
        value = moment(startDate).add(value, "hours");
      }

      if (format === "STRING" && dimension === "ga:nthMinute" && startDate) {
        format = "MINUTE";
        value = moment(startDate).add(value, "minutes");
      }

      const transform = "translate(" + x + "," + y + ")";
      const classNames = [];
      classNames.push('tick');
      classNames.push('tick--' + axis);
      classNames.push('tick--' + position);
      classNames.push('tick--' + format.toLowerCase());

      if (dimension && dimension.includes("ga:")) {
        classNames.push('tick--' + dimension.replace("ga:", ""));
      }

      if (format === "DATE") {
        classNames.push('tick--month-' + moment(value).format('M'));
        classNames.push('tick--day-' + moment(value).format('D'));
      }

      const className = classNames.join(' ');
      return React.createElement("g", {
        transform: transform,
        className: className
      }, React.createElement("line", {
        className: "tick__line",
        x1: 0,
        x2: lineX,
        y1: 0,
        y2: lineY
      }), this.renderLabel(value, format));
    });
  }

  render() {
    const _this$props2 = this.props,
          axis = _this$props2.axis,
          position = _this$props2.position,
          x = _this$props2.x,
          y = _this$props2.y,
          scale = _this$props2.scale,
          ticksPosition = _this$props2.ticksPosition,
          tickValues = _this$props2.tickValues,
          tickSize = _this$props2.tickSize,
          tickPadding = _this$props2.tickPadding,
          tickRotation = _this$props2.tickRotation;
    const transform = "translate(" + x + "," + y + ")";
    const className = "axis  axis--" + axis + " axis--" + position;

    const _computeCartesianTick = computeCartesianTicks({
      axis,
      scale,
      ticksPosition,
      tickValues,
      tickSize,
      tickPadding,
      tickRotation
    }),
          ticks = _computeCartesianTick.ticks,
          textAlign = _computeCartesianTick.textAlign,
          textBaseline = _computeCartesianTick.textBaseline;

    return React.createElement("g", {
      transform: transform,
      className: className
    }, ticks.map((tick, index) => this.renderTick(_extends({
      rotate: tickRotation,
      textBaseline,
      textAnchor: textAlign
    }, tick), index)));
    return React.createElement("g", {
      transform: transform,
      className: className
    }, ticks.map(this.renderTick));
  }

}

_defineProperty(Axis, "defaultProps", {
  format: "integer"
});

export default Axis;